import { render, staticRenderFns } from "./SinglePieHistogramWrap.vue?vue&type=template&id=3d923398&scoped=true&lang=pug"
import script from "./SinglePieHistogramWrap.vue?vue&type=script&lang=js"
export * from "./SinglePieHistogramWrap.vue?vue&type=script&lang=js"
import style0 from "./SinglePieHistogramWrap.vue?vue&type=style&index=0&id=3d923398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d923398",
  null
  
)

export default component.exports